import { useEffect, useRef } from 'react';

/**
 * Store previous value of one variable
 * @param {any} value - variable to save
 */
export const usePrevious = (value) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}

/**
 * Store previous value of one variable, value only changes if update param it's true
 * @param {any} value - variable to save
 */
export const usePreviousConditioned = (value, update) => {
  const ref = useRef();
  useEffect(() => {
    if (update) {
      ref.current = value;
    }
  }, [value, update]);
  return ref.current;
}

export const useFormSkeletonSubscribe = (activateFormElement, deactivateFormElement) => {
  useEffect(() => {
    if (activateFormElement) {
      activateFormElement();
    }
    return () => {
      if (deactivateFormElement) {
        deactivateFormElement();
      }
    };
  }, [activateFormElement, deactivateFormElement]);
}
